"use client";
import React, { useState, useEffect } from "react";
import Mydata from "@/app/data/blog/chicago-Ohare.json";
import style from "@/app/style/servicesetyle.module.css";
import Sticky from "../business-travellers-car-service-dallas/sticky";
import { IoIosArrowDown } from "react-icons/io";

const data = {
  dfwAirport: [
    {
      title: "A Brief Introduction to Chicago O’Hare Airport",
      id: "a-brief-introduction-to-chicago-ohare-airport", // ID based on title
      title1: "Layout of ORD Airport",
      id1: "layout-of-ord-airport", // ID for title1
      terminals: [
        { name: "Terminal 1", id: "terminal-1" },
        { name: "Terminal 2", id: "terminal-2" },
        { name: "Terminal 3", id: "terminal-3" },
        { name: "Terminal 5", id: "terminal-5" },
      ],
    },
    {
      title: "Parking Options at ORD Airport",
      id: "parking-options-at-ord-airport", // ID based on title
      title1: "Getting To and From ORD Airport",
      id1: "getting-to-and-from-ord-airport", // ID for title1
      terminals: [
        { name: "⁠Private car service", id: "private-car-service" },
        { name: "⁠CTA Blue Line Train", id: "cta-blue-line-train" },
        {
          name: "⁠Metra North Central Service",
          id: "metra-north-central-service",
        },
      ],
    },
    {
      title: "Lounges at ORD Airport",
      id: "lounges-at-ord-airport", // ID based on title
      title1: "",
      id1: "", // No ID for title1 since it's empty
      terminals: [
        { name: "Terminal 1 Lounges", id: "terminal-1-lounges" },
        { name: "Terminal 2 Lounges", id: "terminal-2-lounges" },
        { name: "Terminal 3 Lounges", id: "terminal-3-lounges" },
        { name: "Terminal 5 Lounges", id: "terminal-5-lounges" },
      ],
    },
    {
      title: "Conclusion",
      id: "conclusion", // ID for conclusion
      title1: "",
      id1: "", // No ID for title1
    },
  ],
};

function hero() {
  const Data = Mydata[0];
  const { dfwAirport } = data;

  const [isExpanded, setIsExpanded] = useState(true);

  // UseEffect to check screen size on load
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Example breakpoint for mobile view
        setIsExpanded(false);
      } else {
        setIsExpanded(true);
      }
    };

    // Run the function initially
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Toggle function to expand/collapse the content
  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  return (
    <>
      <div
        id={style.blogsiz}
        className={`flex items-end  ${style.blogChicago}`}
      >
        <div className=" opecit w-full ">
          <div
            className=" mb-8 w-full  
       mx-auto px-4 max-w-7xl px-3 "
          >
            <p className="bg-[#d5af34] p-2 mb-2 rounded-lg inline-block">
              Airport Car Service
            </p>
            <h1 className="serviceh1">
              A Guide to Chicago O’Hare <br />
              <span className="main_color">International Airport (ORD)</span>
            </h1>
          </div>
        </div>
      </div>
      <div className=" flex justify-between gap-3  mx-auto max-w-7xl px-4 pt-4">
        <div className="border-1 px-4 rounded-lg border-[#2B3252] text-[#2B3252]">
          Est. Reading Time: 12 mins 36 sec
        </div>

        <div className="bg-[#2B3252] text-white px-2 p-1 rounded-lg">
          31 Oct 2024
        </div>
      </div>
      <div className=" flex justify-end  mx-auto max-w-7xl pt-10 px-6 ">
        <Sticky />
      </div>

      <div className="mx-auto max-w-5xl px-6">
        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: Data.content }}
        ></p>

        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: Data.content1 }}
        ></p>

        <div className="mt-2">
          <h2
            className="blogtitle   "
            onClick={handleToggle}
            style={{
              cursor: "pointer",
              display: "inline",
              alignItems: "center",
            }}
          >
            {/* Title text */}
            <span
              className="border-b-2  border-[#2B3252]"
              style={{ flexGrow: 1 }}
            >
              Table of Content
            </span>

            {/* Arrow icon, rotated based on isExpanded */}
            <span
              className={`arrow  ${isExpanded ? "rotate" : ""}`}
              style={{
                display: "inline-block",
                marginLeft: "10px",
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            >
              <IoIosArrowDown />
            </span>
          </h2>
          {isExpanded && (
            <div className="cardbg mb-4 pl-10 mt-3 pb-2 text-[#2B3252] text-[16px] font-normal pt-4 rounded">
              {dfwAirport.map((item, index) => {
                return (
                  <div key={index}>
                    {/* Title Section */}
                    {item.title && (
                      <p className="blogcontent inline-block">
                        <a href={`#${item.id}`} className="animated-link">
                          {item.title}
                        </a>
                      </p>
                    )}
                    <br/>

                    {/* Title1 Section */}
                    {item.title1 && (
                      <p className="blogcontent inline-block">
                        <a href={`#${item.id1 || item.id}`} className="animated-link">{item.title1}</a>
                      </p>
                    )}

                    {/* Terminal List Section */}
                    {item.terminals && (
                      <ul>
                        {item.terminals.map((terminal, idx) => (
                          <li
                            key={idx}
                            // Unique ID for each terminal list item
                            className="list-disc blogcontent ml-4 "
                          >
                            {/* Anchor linking terminal name with its ID */}
                            <a href={`#${terminal.id}`} className="animated-link">{terminal.name}</a><br/>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Heading with Image (if available) */}
        <h2 id={Data.id} className="blogSubtitle mt-4">
          {Data.heading}
        </h2>
        {/* Additional Content Sections */}
        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: Data.content2 }}
        ></p>
        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: Data.content3 }}
        ></p>

        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: Data.content4 }}
        ></p>
      </div>
    </>
  );
}

export default hero;
